import { useEffect, useState } from "react";
import api from "@/lib/api";

export default function Services() {
  const [services, setServices] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api
      .get("/services")
      .then((r) => setServices(r.data))
      .catch(() => setServices([]))
      .finally(() => setLoading(false));
  }, []);

  const grouped = services.reduce((acc, s) => {
    acc[s.category] = acc[s.category] || [];
    acc[s.category].push(s);
    return acc;
  }, {});

  return (
    <section id="services" data-testid="services-section" className="py-24 md:py-36 bg-melissa-bg">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 mb-16">
          <div className="lg:col-span-5">
            <p className="text-xs uppercase tracking-overline text-melissa-rose mb-6">
              02 — Services & Pricing
            </p>
            <h2 className="font-serif font-light text-4xl sm:text-5xl lg:text-6xl text-melissa-ink leading-tight tracking-tight">
              A short, considered <em className="italic text-melissa-rose">menu.</em>
            </h2>
          </div>
          <div className="lg:col-span-6 lg:col-start-7 text-melissa-inkSoft text-base font-light leading-relaxed">
            <p>
              Each service includes a private consultation, skin prep with clean-luxury
              brands, lashes if desired, and a discreet touch-up kit. Travel within
              the city is included; weddings beyond are quoted on request.
            </p>
          </div>
        </div>

        {loading && (
          <div data-testid="services-loading" className="text-sm text-melissa-inkSoft italic">Loading services…</div>
        )}

        <div className="space-y-16">
          {Object.entries(grouped).map(([category, items]) => (
            <div key={category} data-testid={`service-category-${category.toLowerCase()}`}>
              <div className="flex items-baseline justify-between border-b border-melissa-border pb-4 mb-6">
                <h3 className="font-serif text-2xl md:text-3xl text-melissa-ink">{category}</h3>
                <span className="text-[10px] uppercase tracking-overline text-melissa-inkSoft">
                  {items.length} {items.length === 1 ? "service" : "services"}
                </span>
              </div>
              <ul className="divide-y divide-melissa-border">
                {items.map((s) => (
                  <li
                    key={s.id}
                    data-testid={`service-row-${s.id}`}
                    className="grid grid-cols-12 gap-4 py-6 items-baseline"
                  >
                    <div className="col-span-12 md:col-span-5">
                      <div className="font-serif text-xl md:text-2xl text-melissa-ink">
                        {s.name}
                      </div>
                      <div className="text-[10px] uppercase tracking-overline text-melissa-inkSoft mt-1">
                        {s.duration}
                      </div>
                    </div>
                    <div className="col-span-12 md:col-span-5 text-sm font-light text-melissa-inkSoft leading-relaxed">
                      {s.description}
                    </div>
                    <div className="col-span-12 md:col-span-2 md:text-right">
                      <span className="font-serif text-2xl text-melissa-ink">
                        ${s.price}
                      </span>
                    </div>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-20 p-10 md:p-14 border border-melissa-border bg-melissa-bg2 flex flex-col md:flex-row items-start md:items-center justify-between gap-8">
          <div>
            <p className="text-xs uppercase tracking-overline text-melissa-rose mb-3">A note on pricing</p>
            <p className="font-serif text-2xl md:text-3xl text-melissa-ink max-w-2xl leading-snug">
              Custom packages for wedding parties, multi-day shoots, and destinations available on request.
            </p>
          </div>
          <a
            href="#contact"
            data-testid="services-cta-button"
            className="shrink-0 inline-flex items-center px-7 py-4 bg-melissa-ink text-melissa-bg text-xs uppercase tracking-overline hover:bg-melissa-rose transition-colors duration-300"
          >
            Request a Quote
          </a>
        </div>
      </div>
    </section>
  );
}
